<template>
  <div class="footer-body-wrap">
    <div class="footer-body-content">
      <h2>友情链接</h2>
      <div class="frindlink-content clearfix">
        <ul>
          <li v-for="(item, index) in links" :key="index" class="frindlink">
            <span @click="go(item.linkSite)">{{ item.linkTitle }}</span>
          </li>
        </ul>
      </div>
      <div style="float:right;">
        <img style='height:120px;width:120px;' :src="newProductdetailUrl0" alt="">
      </div>
      <div class="footer-info">
        <div>地址：中国 北京 安定门东大街一号 中国电子技术标准化研究院 </div>
        <div>联系电话：010-64102804</div>
        <!-- <div>传真：010-64102997</div> -->
        <div>邮编：100007</div>
      </div>

      <!-- <div class="gov-Info">
        <div class="gov-Info-item" v-for="(item, index) in govInfoList1" :key="index">
          {{ item.title }}
        </div>
      </div> -->

      <div class="gov-Info clearfix">
        <div class="gov-Info-item" v-for="(item, index) in govInfoList" :key="index">
         <span v-if='item.url' class='itemurl' @click='go(item.url)'>{{item.title}} </span>
          <span v-else>{{item.title}}</span> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { frontPage_queryLinks } from '@/api/modules/home'
export default {
  name: 'Footer',
  data() {
    return {
      newProductdetailUrl0: require('../../assets/img/mark.jpg'),
      govInfoList: [
        { title: '京ICP备05013730号-55', url:'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502043607' },
        // { title: '京公网安备 11010102004595号' },
        { title: '版权所有© 全国区块链和分布式记账技术标准化技术委员会秘书处' }
      ],
      links: [
        // { linkTitle: '清华大学', linkSite: 'http://www.baidu.com' },
      ]
    }
  },
  mounted() {
    this.meths_frontPage_queryLinks()
  },
  methods: {
    go(url) {
      window.open(url, '_blank')
    },
    meths_frontPage_queryLinks() {
      frontPage_queryLinks().then((res) => {
        this.links = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-body-wrap {
  // height: 260px;
  width: 100%;
  background: rgba(40, 42, 50, 1);
  h2 {
    font-size: 20px !important;
  }
  .footer-body-content {
    margin: 0 auto;
    padding: 30px 0;
    width: $base-width;
    color: #fff;
    .frindlink-content {
      padding-top: 20px;
      min-height: 70px;
      width: 50%;
      display: inline-block;
      .frindlink {
        cursor: pointer;
        float: left;
        font-size: 14px;
        line-height: 30px;
        padding-right: 24px;
      }
    }
    .footer-info {
      float: right;
      margin-right:20px;
      > div {
        mix-blend-mode: normal;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        line-height: 24px;
      }
    }
  }
  .gov-Info {
    // display: flex;
   width: 692px;
   margin:0 auto;
   padding-top: 30px;
   opacity: 0.7;
    .gov-Info-item {
      .itemurl{
        // color: #939393;
        cursor: pointer;
      }
      float: left;
      font-size: 13px;
      padding: 0 14px;
    }
    .gov-Info-item:nth-child(2){
       border-left: 1px solid rgba(255, 255, 255, 1);
      // border-right: 1px solid rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/footer.vue